
	import { Component, Prop, Vue } from "vue-property-decorator";
	import { motivoDeRechazo } from "@/helpers/image-upload-helper";

	@Component({})
	export default class ImageUpload extends Vue {
		@Prop({ default: null, required: false }) private model;
		@Prop({ default: null, required: false }) private errors;
		@Prop({ default: 'img_url', required: false }) private label;

		private value = null;
		private rechazo: string | null = null;
		private eleccion = 0;

		// N-255 · Una foto que el backend no admite (un AVIF, aunque se llame .jpg, o una de
		// más de 2 MB) se suelta aquí y se dice por qué AL ELEGIRLA: el 450 del backend no se
		// ve en el panel (N-171). Hasta saberlo no se emite nada; si entretanto se elige otra,
		// manda la última.
		async alElegir(file) {
			const esta = ++this.eleccion;
			const rechazo = await motivoDeRechazo(file);
			if (esta !== this.eleccion) {
				return;
			}
			this.rechazo = rechazo;
			this.value = rechazo ? null : file;
			this.$emit("change", this.value);
			this.$emit("input", this.value);
		}

		clearImage() {
			this.value = null;
			this.$emit("input", this.value);
		}

		get mensajes() {
			return (this.rechazo ? [this.rechazo] : []).concat(this.errors || []);
		}

		get isUploaded() {
			return typeof this.model === "string";
		}

		get getImgUrl() {
			return process.env.VUE_APP_API_IMG_URL + this.model;
		}
	}
